import React from 'react'
import TenantLease from '../Components/Lease Agreement/TenantLease'

const TenantLeasePage = () => {
  return (
    <TenantLease />
  )
}

export default TenantLeasePage